import ApplicationController from "./application_controller";

export default class DebouncedSearchController extends ApplicationController {
  static targets = ["form", "input"]
  static values = { delay: Number }

  declare formTarget: HTMLFormElement
  declare inputTarget: HTMLInputElement
  declare delayValue: number

  private timeoutId?: number

  connect() {
    super.connect()
    this.delayValue = this.delayValue || 300 // Default 300ms (recommended range: 200-500ms)

    // Restore focus after frame reload (debounce only triggers when user is typing)
    const turboFrame = this.element.closest("turbo-frame")
    if (turboFrame?.dataset.restoreFocus === "true") {
      delete turboFrame.dataset.restoreFocus
      setTimeout(() => {
        this.inputTarget.focus()
        const length = this.inputTarget.value.length
        this.inputTarget.setSelectionRange(length, length)
      }, 0)
    }
  }

  disconnect() {
    super.disconnect()
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  search() {
    // Mark that we should restore focus after frame reloads
    // (debounce only triggers when user is typing, so input is always focused)
    const turboFrame = this.element.closest("turbo-frame")
    if (turboFrame) {
      turboFrame.dataset.restoreFocus = "true"
    }

    // Clear any existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }

    // Set new timeout to submit form after delay
    this.timeoutId = window.setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.delayValue)
  }
}
